import { Domain, Endpoint, ApiVersion } from '../Domain';

export class AuthEndpoints {
  static login(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V2), 'login');
  }

  static logout(): Endpoint {
    // Lifestyle backend exposes cookie-based logout at /api/v2/logout
    return new Endpoint(Domain.resio(ApiVersion.V2), 'logout');
  }

  static checkLease(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V2), 'check-customer-lease');
  }

  static signup(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V2), 'users/account');
  }

  static forgotPassword(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V1), 'auth/forgot-password');
  }

  static resetPassword(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V2), 'users/set-password');
  }

  static verifyEmail(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V2), 'users/verification');
  }

  static refreshToken(): Endpoint {
    // Lifestyle backend exposes refresh at /api/v2/refresh
    return new Endpoint(Domain.resio(ApiVersion.V2), 'refresh');
  }

  static changePassword(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V1), 'auth/change-password');
  }

  static config(): Endpoint {
    return new Endpoint(Domain.resio(ApiVersion.V2), 'config');
  }
} 